import { decodeCmcd } from './decodeCmcd.js';
/**
 * Decode CMCD data from a url encoded string.
 *
 * @param url - The url encoded string to decode.
 *
 * @returns The decoded CMCD data.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/fromCmcdUrl.test.ts#example}
 */
export function fromCmcdUrl(url) {
    return decodeCmcd(decodeURIComponent(url.replace(/^CMCD=/, '')));
}
//# sourceMappingURL=fromCmcdUrl.js.map